import React, { FC } from 'react';
import { Redirect, Switch, useRouteMatch } from 'react-router';
import { PrivateRoute } from 'common/AuthRoute';
import DevicesPage from 'pages/SuperAdminModule/DevicesManagement/DevicesPage';
import { RegisterNewDevicePage } from 'pages/SuperAdminModule/DevicesManagement/RegisterNewDevicePage';

const DevicesManagementPage: FC = () => {
  const { path } = useRouteMatch();

  return (
    <>
      <div>
        <Switch>
          <Redirect exact from={path} to={`${path}/list`} />
          <PrivateRoute
            path={`${path}/new`}
            component={RegisterNewDevicePage}
          />
          <PrivateRoute path={`${path}/list`} component={DevicesPage} />
        </Switch>
      </div>
    </>
  );
};

// eslint-disable-next-line import/no-default-export
export default DevicesManagementPage;
